<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western4" id="calibre_pb_9"><a id="Ch1_1"></a> <span class="c5"><a href="#/tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_007#ref_TOC">CHAPTER
ONE</a></span></h1>
<p class="western1"> <br class="calibre1"/></p>
<p class="c6">My phone rang with the forlorn tune, “Hall of the
Mountain King”. “Allexa Smeth,” I answered, already knowing who it
was by the ring tone.</p>
<p class="western1">“Allexa, thank goodness I’ve finally reached
you! Where are you right now? Are you still in lower Michigan at
your sister’s?” Liz Anderson, the county manager, who happened to
be my sometime boss, had that impatient tone to her voice that I’ve
come to recognize as her trying to do too many things at one
time.</p>
<p class="western1">“Yes and no,” I replied. “I’m still
downstate, but I’m not at my sister’s anymore. I’m in Indian River
having lunch with a friend, about half an hour from the bridge.” It
had been too long since I’d seen my friend Soozie and I was
enjoying our time together, even though I had left my sister Pam’s
a day early because of an unsettled feeling in my gut. “What’s
going on, Liz?” I asked nervously.</p>
<p class="western1">“I think it would be a good idea for you to
get on <i class="calibre2">this</i> side of the bridge. We might have to shut down
our borders and that starts with the Mackinaw Bridge.”</p>
<p class="western1">“<i class="calibre2">What</i>? Why?” I asked, feeling my heart
miss a beat. This could only mean bad news.</p>
<p class="western1">“I can’t say too much on the phone, Allexa,
but something strange is happening and I want all of my township
emergency managers where they belong. You’re one of the few EM’s
that actually take their position seriously and let me know when
you’ll be out of town.” Liz sighed and took a breath before
continuing. “Look, please get back into the U.P. as soon as you
can, okay?” With that she hung up, leaving me staring at my
cellphone.</p>
<p class="western1">Eight years ago I accepted the appointment of
emergency manager for my small town of Moose Creek in the Upper
Peninsula as a means of giving back to the community for the peace
I finally found. The appointment was for the entire township of
eight hundred people, not only for the two hundred souls that lived
in the town itself. Very rarely have I been called on to exercise
the knowledge I’ve gained from the ongoing education that’s
required, however, I made a commitment and I always honor my word.
I lived deep in the woods with a bipolar narcissist for seven
uneasy years, barely making it out alive. The town and the people
healed me. I owe them.</p>
<p class="western1">“Well, Soozie, looks like I have to go,” I
said sadly, pushing my unfinished burger aside and easing up from
the red and white vinyl seats of the booth we sat in. I looked
around at the quaint restaurant, with the red stained-glass
lampshades that hung over each table by heavy copper chains and
snifter candle holders that sat, waiting for dusk to be lit.</p>
<p class="western1">“Before you leave, Allexa, I have something
for you.” Soozie slid a small package toward me across the scarred
and heavily varnished wood table. I removed the pink tissue paper
to reveal a beautiful brown leather book, laced up the back binder
with strips of rawhide. “It’s a replica of a Civil War diary,”
Soozie explained.</p>
<p class="western1">The smooth and rough textures of the leather
held me spellbound, as though the book was trying to decide if I
was worthy of it. Silly I know, yet I felt it was imprinting itself
on my heart while I held it gently to my chest. I decided right
then to start using it tomorrow.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">I came around the final curve of the road,
and the bridge came into view. It never ceases to thrill me to get
the first glimpse of those towering pylons strung with heavy
cables. After being away, even if it’s only been for a few days,
the sight is still humbling. The Mackinaw Bridge is the longest
suspension bridge in the United States at a little over five miles,
and the only physical connection Lower Michigan has with its
sister, the Upper Peninsula. The U.P. has been my home for the past
eighteen years and I can’t imagine living anywhere else.</p>
<p class="western1">The thrum of my tires against the
rain/expansion grates rang in my ears when I got to the center of
the bridge. The tug on my tires reminded me I was almost back in
the U.P. I happily paid my toll and continued on I-75 until the
Highway 123 exit. The two lanes of 123 meandered through pine
forests and open fields, small settlements, and then finally into
the town of Trout Lake where I stopped for a short break. I
purchased a hand dipped cone of Moose Tracks, a rich vanilla ice
cream with swirls of caramel and fudge and chunks of peanut butter
cups. It had been an arduous few days and I felt entitled to the
decadent treat. Back in the car, it was another twenty minutes to
the next turnoff onto M-28. From there it was a straight shot to
Marquette, and still three more hours of driving.</p>
<p class="western1">It would be about 4:30 PM when I arrived, and
with any luck, Liz would still be in her office at the State Police
post.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">“So can you tell me what’s going on?” I asked
Liz when I sat down in a soft black leather chair.</p>
<p class="western1">“Since talking to you, I’ve made a <i class="calibre2">lot</i>
of phone calls, only to find out the rumored terrorist threats have
been only a <i class="calibre2">drill.</i> One that no one bothered to tell me
about.” Liz leaned back and closed her big pale brown eyes. “I’m
sorry to have yanked you away from your visit. This job gets to me
sometimes,” she confessed. “It’s getting harder and harder to
decide when to act on a rumor or lead, or when to wait until
confirmation.”</p>
<p class="western1">“Why a terrorist drill up here? That doesn’t
seem likely. What would be the point?”</p>
<p class="western1">“Not a drill with us directly involved.
Though it is going on in several nearby major cities. It’s to show
how a takedown of infrastructure would disrupt commerce
everywhere,” she explained. “The main commerce being discussed
would be food distribution. If the food stops, things will get
nasty very quickly.”</p>
<p class="western1">“It was only a drill then? That’s a relief!
My training doesn’t include food riots,” I joked, yet I was also
serious.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">Maybe the journal from Soozie will help me
get more organized. This weekend I think I will do an inventory of
food and supplies in preparation for winter.</p>
<p class="western1">I’m extra pleased with the garden. It has
done great and I’ve canned more this year than ever before. Being a
prepper has its advantages in the long run, at the same time it’s a
lot of work. I’ve been stocking over the summer the best I could,
even with my hectic work schedule. With the threat of food
shortages from a terrorist attack, drill or not, I’m extra glad
I’ve done all I have.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">Last week was the final day of work at the
resort for the season. I’m <i class="calibre2">so</i> glad it’s over. I look forward
to it every spring, and then by September 1, can’t wait until it’s
done. I’m past tired, I’m exhausted. Doing five and six massages a
day, three, four, even five days a week is getting too hard on my
aging body. Twenty-eight years of it has taken its toll. Maybe I
should consider retiring, at least then I would have more time for
the garden.</p>
<p class="western1">On the last day I performed six massages and
injured my shoulder. A brutal day. It didn’t help that it was
rainy, windy and cold. At least now I can rest.</p>
<p class="western1">What I would miss most about work was the
people and the location. The resort is over twenty thousand acres
of privately held nature reserve. Each day that I drove the five
miles from the guarded gate to the compound where all the cabins
are was a delight. The lush forests of deciduous trees give way to
giant pines and then back again on the two-lane dirt road. I was
always offered something new. It might be some new flower or
mushroom growing alongside the road, or it might be the deer that
stared at me before they sauntered off into the underbrush, knowing
they were completely safe.</p>
<p class="western1">One of the most memorable sights I had was
watching a young coyote jumping playfully in a field, catching
grasshoppers to eat. I watched for five minutes before it realized
I was there, then like a wisp of smoke it was gone. <i class="calibre2">The</i> most
incredible experience was when I rounded a curve and came face to
face with a moose calf once, one of the adolescents that
occasionally hung around the entrance gate. I knew the moose were
here but had never seen them. I stopped the car less than twenty
feet from her, and watched the huge animal in the middle of the
road. When I first saw her I thought she was a horse, however, when
she looked at me with that unmistakable large head and the long,
wide snout, those long, gangly, powerful legs, there was no denying
what she was. My first moose sighting was up close and personal. It
only lasted a few minutes, then she turned, giving me a full,
breathtaking side view, and deftly leaped the berm and walked off
into the dappled shadows of the woods. My cellphone was dead so I
don’t have any pictures except for the ones in my memory.</p>
<p class="western1">Then there were the owner/members of the
Resort. Being their massage therapist for the past sixteen years
had given me an insight into a world of the elite and wealth that I
never would have seen on my own. The members are wealthy—some very,
some extremely. I often heard about their month long vacations to
Italy in the spring, the weeks in the Bahamas during the winter,
plus the trips to Europe with jaunts to Paris and London then on to
Rome. What I admired most though, was that they were all really
very down to earth people. I’d seen them shopping at the local big
box stores or pumping their own gas.</p>
<p class="western1">One time I asked an older client for some
advice on the British hierarchy, prepping for a costume party that
I was hosting. After she explained the pecking order of a Duke to
an Earl, a Duchess to a Lady, she laughed and said, “I must tell
you the most amusing story about when Prince Philip came to visit!”
I was amazed, though not surprised that she actually knew the
British royal family. I have mourned the ones who have passed right
along with their peers, not embarrassed to sob at the Resort held
memorials. Yes, I would miss the people the most. Many of them had
become dear friends, and I would see them next spring.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">I did a cursory inventory of the freezer room
pantry, the first of three separate storage areas. There wasn’t as
much beef or chicken broth as I would like, but it was something I
could make. I also had some fruits, canned beans for quick use, one
hundred pounds of flour, light bulbs, all kinds of miscellaneous
stuff, plus all my herbs and seasonings. The wine rack my son Jason
built isn’t really full, yet I’d say there were four cases of wine,
though some was my cooking stock: Marsala, Sherry, and Port. I
wasn’t worried about how much wine was (or wasn’t) there. The
freezer itself, even though it’s only twelve cubic feet, was
packed. I had lots of beef and chicken, some pork, some fish, ten
pounds of butter, and a few bags of wild mushrooms. I could
probably live off the freezer alone for many months. I have
difficulty passing up a good sale.</p>
<p class="western1">The entry pantry was stocked with “stuff”:
paper goods mostly, and water filters. I have a year’s worth of
toilet paper, six months of paper towels, and if I run out, I could
use towels and wash them, like Granny did. Installing shelves in
there has helped organize that area. I also put in small tubs and
labeled them (dental, deodorant, band aids, wipes, misc.), which
helped keep track of what was where. There’s also plenty of
toothpaste, deodorant, and OTC pain meds.</p>
<p class="western1">My medical bag is good. My friend Shine
helped me with that last year—sutures, scalpels, iodine, tissues,
blood pressure cuff and stethoscope, plus a dental kit. I certainly
didn’t need to worry about shampoo and conditioner now that my hair
was so much shorter. A few weeks ago there was a 10 for $10 sale on
popcorn so I loaded up and stored it in the front pantry. That’s
where Tuft’s litter box is, so checking the stock reminded me to
check in the barn for how much spare litter I have for the winter.
I need to stock up on dish soap, since there are only four bottles
under the sink. I have a couple of tubs of powdered washing soap
out in the barn that should last a while, but not indefinitely.
Then there was the back room pantry. I’ve outdone myself with the
canning this year and am really pleased. I sure won’t go hungry.
All in all, I’m happy with my supplies and food stores. I’ve worked
hard at it and it shows.</p>
<p class="western1">I do need to make a run to the artesian well
soon; I’m almost out of drinking water.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">I dug up some horseradish roots a few days
ago. The plants did great this summer and the leaves were four feet
tall. Earlier in the summer I dried some of the leaves for
seasoning on the other hand actually making horseradish from real
roots is a new thing for me, so I asked the online prepper groups
how to do it. Someone gave me a warning to wear my gasmask. I
thought that was silly, but at least that warning got me to get out
the N95 mask and the face-sealed goggles and surgical gloves. I set
up a table on the deck with the food processor outside and set
about making the horseradish.</p>
<p class="western1">I scrubbed the roots with no problem. I
peeled the roots with no problem. It was a pleasant scent. I love
horseradish. I took all outside and shredded the roots. When I took
the lid off of the processor, my eyes burned through the goggles
and my nose immediately started to run. OMG... the fumes! YIKES! I
dumped the pulp into a glass bowl without going blind and reset it
with a chopping blade instead of the shredder and pulsed it several
times. Finally it got to the consistency that I wanted. I held the
bowl away when I lifted the lid and even still, my eyes watered
again. I dumped the chopped root back into the bowl and put a cover
on it, then I lifted the goggles and wiped my eyes after I rinsed
my gloved hands. I added half cup of my own Apple Cider Vinegar,
and stirred it all in. I covered the bowl with a plastic cap and
then washed everything. I wasn’t about to bring that stuff inside,
so I took the prepared jars out to the deck and filled them with my
fresh horseradish.</p>
<p class="western1">Next time I just might use the gas mask. It
was quite an experience, and the end product is incredible. It was
a good thing the weather was nice. It made me want an outdoor
summer kitchen. Maybe next year.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">Now that the resort has had closed, it was
past time I attacked my fall prep list. There was <i class="calibre2">so</i> much to
do, and I still lament I must do it on my own. Looking over the
list, I was pleased that I had tackled many of the really important
items early.</p>
<p class="western1">The winter wood was delivered in May. I was
thankful that Keith let me pay for it when work picked up. This is
the first year I managed to stock a full eighteen months’ worth of
wood. Every now and then I get the feeling that we’ll have a bad
winter and I’m going to need all of that wood. It hasn’t happened
yet, still, one of these years it will.</p>
<p class="western1">I use propane for cooking, even though the
cook-stove let me do everything I need. Even though I haven’t used
much of it, I still called for a winter top off for November first.
One more thing off the winter prep list.</p>
<p class="western1">I hadn’t rototilled the garden yet, but I had
shut it down and let the chickens run free. This was a really great
garden season. I was able to can more tomatoes than ever before,
plus greens and squash and beans.</p>
<p class="western1">Back in late August sometime I ran into Mike
T., a local farmer, and arranged to barter my tomatoes for some of
his corn. Unfortunately, before I could collect, his corn was gone
and I had to buy some. Oh well, at least I have two cases, and
that’s better than nothing.</p>
<p class="western1">I still need to shut the outside water off.
An onerous task since I don’t like going down in that eight foot
deep pit where the valve is located.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">I love productive days. The weather is
holding, sixty-eight degrees today and mostly sunny, a good day to
be outside. I dug up a pound of Jerusalem artichokes. Too bad they
don’t keep well; I’ll keep adding them to meals before they spoil.
I relocated some of them to another part of the garden. I hope that
they take.</p>
<p class="western1">I cleaned out the onion beds, planted some
garlic, and dug up as many of those darn creeping weeds with the
geranium-like leaves as I could. The wheelbarrow was completely
full. I knew they’d be back, at least these wouldn’t be tilled
in.</p>
<p class="western1">I took down the fence charger and pulled up
the cord, storing it all in the barn for next year. One more task
to add to the winter prep-fall chores list since it was a new
addition this summer. I left the wire at the top on the fence in
place. I will have to see how it fares this winter.</p>
<p class="western1">I washed sheets and hung them out on the
line, then did all my laundry.</p>
<p class="western1">The day was still young, so I decided I’d go
for a walk.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">I ended up on the public side of Eagle Beach.
It was wonderfully quiet this time of year since all of the
tourists were gone and the kids were in school. I had the whole
beach to myself. I walked for a bit and then found a large piece of
battered driftwood to sit on. Where this piece of wood came from is
anybody’s guess. Lake Superior is a huge lake and it might have
come from Canada or the other side of the bay. In spite of it being
cool, I took off my shoes and dug my toes into the damp, rocky
sand. I sat there for a while watching the waves gently lap at the
shore, trying to think of what I wanted for this coming winter. Try
as I might, my mind kept drifting.</p>
<p class="western1">I remembered a night so long ago, when my ex
Sam and I were new to the area and still working on our house in
the woods, long before we split up. It was a warm August night, the
moon was new, and there wasn’t a cloud in the sky. Sitting on the
beach at midnight and looking at all the stars was mesmerizing.
There is no light pollution up here and the sky was brilliant. From
the bay, the view out to Lake Superior is more than 180 degrees.
That night there were so many stars I could actually see a subtle
curvature of the universe. I know it was an optical illusion, but
the sky seemed to bend around us. I will never forget that
night.</p>
<p class="western1">I dug my toes a bit deeper and felt something
sharp. Digging with my fingers, I found a nice piece of hematite to
add to my rock collection and stuck it in my pocket. After
disturbing the sand, I was visited by a couple of squawky white and
gray seagulls, curious if I dug up anything for them. They can be
annoying little creatures and it’s part of life on the lake. Almost
immediately, there was another shriek, then another. They have some
kind of code in that caw, I swear. Soon there were a dozen of those
pesky birds swooping down, their raucous cry piercing the quiet,
parading up and down the shore or fighting with the next one for a
piece of twig. It was a good thing I didn’t have any food or else
they’d never leave.</p>
<p class="western1">My attention kept coming back to the first
house on the other side of the break wall, which separates the
public beach from the residential section with the marina. That
first house is where John Tiggs and his co-workers live. I’d been
seeing John as a massage client for a year now and I’ve grown
dangerously fond of him. During our many hour-long sessions
together, he has told me much about himself, past relationships and
how he never wants to be emotionally tied to anyone ever again. I
wish I could say the same.</p>
<p class="western1">I pulled my focus away from that house to
watch an ore freighter chug its way across my view a few miles out.
Last year during a particularly violent storm, a thousand-foot
freighter took refuge in the much calmer waters of our bay. It was
startling for me to see this huge ship anchored calmly. I had
forgotten how vast our cove is, at least five miles across making
the ship look like a small toy boat in a big bathtub. It stayed for
two days and then left quietly during the night when the storm had
passed.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">The television news tonight covered a riot in
Miami. It seems that an entire district didn’t get their food
stamps due to a computer glitch, so they stormed the local social
services office. When they couldn’t get in (some smart worker
quickly locked the doors) the crowd went on a rampage, breaking
into stores, looting and setting fires. Due to being short on
manpower because of budget cutbacks, there was little that the
police could do, so they barricaded the area off to keep more
people from entering and let the crowd burn itself out. Apparently
one of the caseworkers took charge of the rest of the employees and
got them upstairs where they jammed the elevator doors open so it
couldn’t be called down.</p>
<p class="western1">The guy put an “out of order” sign on the
elevator doors on the main floor and duct taped over the buttons so
it wouldn’t show where the elevator was. He used the janitor’s keys
and locked the stairwell doors behind him. The final count was
seven dead, and one hundred twenty-six injured. One of the dead was
a caseworker who wouldn’t retreat. When he tried to get to his car,
the crowd beat him to death.</p>
<p class="western1">If people will do this because their food
stamps were late, what will they do if something really bad
happens?</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c7">JOURNAL ENTRY: October 23</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">Today was my son Eric’s birthday. It’s hard
to believe that he’s older now than I was when he was born. I
called him even though it was hard to wish him a happy birthday
when he and Beth are splitting up. Damn, I really like my
daughter-in-law. Eric is coping. That’s the best thing the military
did for him, gave him coping skills. He’s a good man and a good
father. Perhaps that’s what <i class="calibre2">I</i> did for him: teach him how to
be a good parent. I’m so proud of him and it makes me weep
sometimes.</p>
<p class="western1">I’m proud of Jason too, in different ways.
Jason has turned into an amazing father. Having an autistic child
is difficult, however, he’s done well.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">I got my rototiller back from Jason and then
hired his helper, Abe, to till the garden. My grip has been bad
from all the massage work, but with a winter to recover, it would
be better by spring. With the ground broken, I’ll be able to run
the tiller myself. Jason took the gutters down from the barn that
feed the cistern, and then turned the cistern over while Abe tilled
the garden. That’s two more things off of my list.</p>
<p class="western1">A few days ago, I came across one of those
hard-to-pass-up deals— a clearance sale on chicken legs, what I
call a “use or lose” sale. The legs, all twenty-five of them, went
into a big pot for soup, which I canned today. Eleven pints, heavy
on the chicken, along with the two packages of boneless thighs,
making eight more pints. I couldn’t help it. When I see prices like
that, I feel the need to buy it.</p>
<p class="western1">The weather is now cool, low fifties, cloudy
and dreary. Saturday the temps are supposed to drop into the
thirties for the high, so it looks like winter is closing in on us.
I think I might run into town and get two more bags of chicken feed
and see if rock salt is in stock yet. It should be— I’ve seen
Christmas displays already! Geesh, what happened to the day
<i class="calibre2">after</i> Thanksgiving?</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c7">JOURNAL ENTRY: October 24</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">I keep looking at my list, and looking at it
again. Why am I hesitating to finish it? The water is a big issue.
So many times after I’ve turned it off, I find something that I
need to hose down, or wash outside, which means turning it back on.
I’m also reluctant to empty and winterize the hot tub. This is the
perfect time to use it, as the nights are getting chilly. I do love
a good long soak. I give therapy all summer long and the hot tub is
<i class="calibre2">my</i> therapy.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">When I arrived for my morning massage with
John, all the guys there seemed antsy and irritable, which is
unlike them. They’re usually pleasant and jovial. I wonder if
they’re having more problems from the locals.</p>
<p class="western1">These guys might be miners at a very
controversial local mine, but they are also a bunch of the nicest
guys I’ve met, and they’re trying very hard to fit in with the
community. Doing a massage off to the side in the large dining area
lets me be the proverbial fly-on-the-wall. These guys are from all
over, literally. Lance is from Ireland and I can listen to him talk
for hours. Sven is from Sweden, John from North Carolina, and none
of them are from Michigan. I think that was intentional.</p>
<p class="western1">Most of them have degrees in something
related, like management or geology, or specialize in explosives,
and they are all intelligent and polite. Their language is rather
rough; it comes with the territory. Actually, that they talked like
that in front of me made me feel more accepted.</p>
<p class="western1">I don’t know why the guys are acting
peculiar. John said some of them get “feelings” about earth
movement, that there had been some, and that it was making them all
extra cautious.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c7">JOURNAL ENTRY: October 25</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">The weather report isn’t good. We are
expecting cold rain and thunderstorms for the rest of the week, so
I drained the hot tub and dumped the two gallons of anti-freeze in,
wrapped up the screen netting, and took down the umbrella. Another
major project done, and I’m sure going to miss it. With it sitting
outside on the deck, I can’t afford the extra money every month to
heat it during the winter.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">I was on a roll. I’d been waiting for gas
prices to drop so I could refill the drum. This morning it dropped,
not much, down to $3.75. Outrageous, but I’m way too nervous about
not having full drums. I’ve always had it refilled by now, however,
it has been too expensive. I needed eighty gallons to refill
everything. That came to a lot of money; on the other hand, I did
feel better having the drums topped off even at that price. It took
several hours of running back and forth this morning, twenty
gallons at a time, trying to time the shift change at Fram’s so it
wasn’t so obvious what I was doing, and now I felt so much more
confident with full drums.</p>
<p class="western1">If a snowstorm takes down the power I need
gas for the generator. Depending on how long it stays down, I could
need a <i class="calibre2">lot</i> of gas. The two drums and four cans gave me 130
gallons to get through an emergency.</p>
<p class="western1">While I was doing that, I dropped off all the
heavy comforters, blankets and pillows at the Laundromat. That
storm front must have missed us. The weather was still reasonably
okay to dry it all on the clothesline, even with the nighttime
temperatures getting into the forties. That the rain had held off
so far was a bonus. The temperature actually hit sixty-seven
yesterday, not what was predicted at all.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c7">JOURNAL ENTRY: October 26</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">Well, that was short lived. We’re now under a
severe thunderstorm warning with possible hail. The blankets are
draped over chairs in the kitchen, drying very, very slowly. At
least they won’t get any wetter. I bet Jacob would love it here
with all these “blanket tents” to play under. It is fifty-seven
degrees and too warm to start the stove to help with the drying.
Other than the pillows, it’s also all too large to fit into the
dryer.</p>
<p class="western1">I’m pleased that at least I got the gas in. I
pushed some boxes out of the way, and parked the car in the barn.
Quarter-sized hail can do some damage!</p>
<p class="western1">Everything has shifted fast. It’s dark out
now and a thick fog has settled in. I can hear the thunder in the
distance. Tufts is not happy about staying in. He might be a big
kitty but he’s a coward at heart. The first crack of thunder and
he’ll be hiding under the bed.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">Tufts the cat is my friend and companion. I
remember when I first brought him home. I was his fourth home in
four months, and he was scared to death. I had lost my long haired
white cat CeeCee six months before to cancer. That was a long and
lonely six months for me. Then I saw an ad in the paper: Free to
good home, long haired black cat, neutered, all shots, declawed,
owner allergic.</p>
<p class="western1">I called and picked him up the next day. The
first owner was moving into an apartment and couldn’t take him, so
he went to the pet shelter to await adoption. The next owner wanted
another black cat for a friend to their current black cat, only
that cat wasn’t adapting. The third owner was more loyal to her
other cat, which I understood. After a week with me, I saw the cat
sitting at the glass door staring out, the sun shining in,
illuminating the grayish tufts in his ears and on his tummy, and he
became Tufts. He’s been a wonderful, affectionate cat that needed
one owner (not a family) and to be an only child. Now, his golden
eyes greet me every morning and I spoil him rotten.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">The storms have completely moved out and it’s
cool and sunny. I took all the curtains down, washed them, and put
them out on the line. I can’t believe how much I’m getting done.
It’s difficult to do all this by myself. I have to first remember
what to do, then do it and do it right. Not doing a chore right is
as bad as not doing it at all, especially when it might be one of
those vital things like turning off the outside water, or filling
the hot tub lines with anti-freeze. It could be disastrous if not
done, or not done properly.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">After I washed down the hearth of the wood
cook-stove, I brought in a full load of wood. I had to fire the
stove up this morning. It was chilly, only forty-two degrees out,
and I didn’t expect the temperature to go much higher.</p>
<p class="western1">The fall colors are wonderful as usual, yet
also go away quickly. With a predominance of maple trees up here,
there is a vivid display of red, orange and yellow that draws
people from all over for the Color-Tour, our last hurrah for
tourism. It’s hard to believe that the peak color was two weeks ago
and now we have bare trees. What an amazing transformation.</p>
<p class="western1">At least there’s been no snow yet. I remember
one year when there was a foot of wet, heavy snow even before the
leaves dropped. It brought down countless trees and took the power
out. Mine was out for four days; others for over a week. The power
company did massive trimming the next spring to keep it from
happening again.</p>
<p class="western1">The forecast is for flurries on Sunday so I
put the chickens’ winter walls up on the inner yard, yet another
thing off of my list. Putting those sheets of thin plywood over the
secure fencing keeps the blowing snow out of their small yard and
the roof keeps everything else out. The chickens are happy when
they are able to get out to scratch around in the dirt, and happy
chickens lay more eggs.</p>
<p class="western1">My best friend Kathy called last night to see
if I was going into town today so she could hitch a ride. Her
husband Bob was already in town for a day-long workshop and there
was a hockey game they wanted to watch later. Since I had planned a
quick run, I told her I could drop her off and save Bob from coming
back those thirty miles to pick her up.</p>
<p class="western1">Jason is planning to come for dinner tonight
with Jacob and requested “meat,” so I need to shop. I suppose I
could pull something out of the freezer...</p>
<p class="western1">I found a couple of steaks that should
satisfy Jason’s appetite. Those, along with some steamed carrots
with Swiss chard and a salad will make a nice dinner.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c7">JOURNAL ENTRY: October 27</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">A major hurricane is making its way up the
East Coast. New York City provides over 350,000 free meals each
day, on a <i class="calibre2">normal</i> day. I wonder what will happen if there is
no food to give out during or after this storm?? People can get
real ugly when they’re hungry.</p>
<p class="western1">The weather here is strange, though I doubt
it’s an effect from the storm. The skies are clear at night so it
got cold, only thirty-three degrees when I got up. When the sun
came up, the clouds rolled in so there was no solar heating.</p>
<p class="western1">I left one cherry tomato plant in the garden,
covered at night with a frost bag. The few tomatoes on it won’t
ripen without warmth, so I needed to pick those and bring them
inside, then pull the plant up. There’s also most of the short row
of Swiss chard that seems totally unaffected by the cold. I picked
some last night for dinner, so that I will leave alone to enjoy
while I can. It’s time to dump the flowers on the deck and put the
planters underneath. One more thing to cross off of that nagging
prep list.</p>
<p class="western1">Eric called to tell me that he is going to
come up for Thanksgiving. Wow, two visits in two months. I wonder
what’s up?</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">Jason brought Jacob over around noon. He had
a job to do that would take him a few hours, and since Amanda, my
daughter in law, is still out of town, I agreed to watch my nine
year old grandson. Jacob is autistic and takes a bit more attention
at times, but he plays so well by himself that it was easy to
continue with my chores. I dumped the flowers, hauled in wood,
changed the litter box, and did some laundry. Then Jacob and I went
for a short walk along my road.</p>
<p class="western1">Jason showed up around 5:30 P.M., just in
time for dinner. I made two Cornish hens, stuffed with fresh herbs
and cooked in the woodstove oven, served on a bed of basmati rice
with a side of Swiss chard. It was nice to cook for someone besides
myself. Jacob is fussy a eater, so I always keep chicken nuggets or
noodles on hand for him. He loves noodles.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c7">JOURNAL ENTRY: October 28</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">No snow, although it sure is chilly! It got
down to thirty degrees last night. I built a nice fire in the cook
stove, started a new book, and spent the day relaxing. The fire
felt good, and I’m planning to cook a pot roast for dinner, a nice
long, slow cook. Yum.</p>
<p class="western1">It looks like that hurricane is going to
wreak some havoc on the East Coast. The media is calling it a
“perfect storm”, a nor’easter colliding with a cold front from the
west. They are predicting that some areas might see fifty inches of
snow! Even up here we don’t get that in one fall. The most that
I’ve ever seen is forty inches when I still lived deep in the
woods. That was a blizzard to remember, long before the Weather
Service was naming winter storms.</p>
<p class="western1">Over on one of my internet groups, Survival
Retreat, the speculations have already started on whether or not
the hardest hit areas of the storm are going to be able to hold
elections next week, or if they’ll be suspended. That’s never
happened before.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="c1">* * *</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">Today is the last Monday of the month. I paid
my bills for November online. Gosh, I love doing that! They are all
done and will go out when they should, automatically. I still
needed to plug in an amount for the propane bill, since the fuel
will be delivered on Thursday. It felt really good to have enough
in the checking for the rest of the year, with the balance in the
savings, ready to transfer over, providing no expensive emergencies
come up.</p>
<p class="western1">It was twenty-five degrees this morning, and
the furnace failed to come on when it was supposed to. However,
when I bumped up the temperature manually, it kicked right in.
Hopefully it was only a glitch. The woodstove is going now and it’s
quite comfortable. The temperature outside has risen to forty-five
degrees and the skies are a deep blue with near blinding
sunshine.</p>
<p class="western1">I got another winter prep done. I recharged
the generator battery for easy starting. It isn’t hard to start it
with the cord, but my shoulder still isn’t one hundred percent and
I don’t want to re-injure it. The generator has the capability to
start by either pull cord or key, and the key method requires a
battery to furnish the necessary power. Jason got it all rigged for
me after I got the right sized battery. When the gennie runs, it
charges the battery, although if I don’t use it for months on end,
the battery gets drained. I finally got the trickle charger Jason
suggested and can now keep the battery level where it needs to be.
I didn’t have these issues in the woods: Sam ran the generator
daily to do his stained glass art and he did all the maintenance on
the gennie. I sure had a lot to learn after we split up.</p>
<p class="western1">I had to do one last sweep of the deck. I
don’t know where all these leaves are coming from, there sure
aren’t any more on the trees!</p>
<p class="western1">It might be a good day to clean off my
computer desk and the shelf overhead. Maybe my art table too. That
might give me the incentive to start painting Christmas cards
again. I used to hand paint all of our cards when I lived deep in
the woods. Watercolor art came easy to me and I really enjoy it. I
would work with two or three designs and then duplicate them
individually. That last year in the woods I made seventy-five
cards. After we broke up, one of Sam’s friends asked if he could
stay on my Christmas card list. That was flattering, but not so
touching as when I found all of my cards in Mom’s drawer after she
died. She didn’t keep any other cards, only mine.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_010.vue?3dd6f821